import React from 'react'
import '../Component/css/Todo.css'
import { useNavigate } from 'react-router-dom'
import header from '../assets/product/todo/header.webp'
import header2 from '../assets/product/todo/header2.webp'
import header3 from '../assets/product/todo/header3.webp'
import header4 from '../assets/product/todo/header4.webp'
import todobg from '../assets/product/todo/todobg.webp'

// video
import todoVideo from '../assets/product/todo/todo1.mp4'
import tododjangoVideo from '../assets/product/todo/todo_django.mp4'



const Todo = () => {

  const navigate = useNavigate()

  return (
    <div className="about">
      <section className="about-section sec-padding">
        <div className="container">
          <h1 className='projecth1'>Product.</h1>
          <div className="project-row">
          <div className='todo-project'>

{/* IMAGE BACKGROUND */}
          <img src={todobg} alt="background" className='treebg' />

{/* TIMELINE */}
    <div className="timeline">
                  <ul className='todo-ul'>
                    <li className='todo-li'><div className="li">Challenge</div><span>The design should encourage users to finish tasks and boost individual productivity in the workplace.</span></li>
                    {/* <li className='todo-li'><div className="li">Role</div><span> Product Design and Backend Development</span></li> */}
                    <li className='todo-li'><div className="li">Sector</div><span>Productivity | Business | Worklife</span></li>
                    <li className='todo-li'><div className="li">Timeline</div><span>3 Months</span></li>

                  </ul>
                </div>  
{/* HEADER 1 */}
            <div className="todo-header-body">
              <div className="header-detail">
                <div className="header-text-one">
                  <div className="main-text-one">
                    <h3>About</h3>
                    <div className="todo-icon">
                    <i class="fa-brands fa-google"></i>
                    <i class="fa-brands fa-apple"></i>
                    </div>
                  </div>  
                    <p>
                    A personal task management app for professionals in the workforce. The project aimed to design a task management app that improves productivity of individuals at work. The design takes a minimalist approach without compromising accessibilty, aesthetics, and functionality. The source code is on my <strong><a href="https://github.com/TundeAdekoya/todo-task-manager-api" target="_blank" rel="noopener noreferrer">GitHub Repository</a></strong> and live on <strong><a href="https://todo-task-manager-api.herokuapp.com/" target="_blank" rel="noopener noreferrer">Heroku</a></strong>. The design prototype is on  <strong><a href="https://www.figma.com/proto/IaMObUnBXXtbZyVJTQ4EsG/Task-Manger?page-id=0%3A1&node-id=9%3A583&starting-point-node-id=16%3A513&show-proto-sidebar=1&scaling=scale-down" target="_blank" rel="noopener noreferrer">Figma</a></strong>
                    </p>             
                  </div>
                </div>
              </div>
              <div className="header-image-one">
                <img src={header} alt="TodoHeaderImage" />
              </div>
  {/* END */}
  
{/* GOAL */}
            <div className="todo-goal">
              <div className="todo-goal-text">
                <h3>Goal</h3>
                <p>The aim was to design a task management app that combines a simple user interface with an easy user experience. In addition, gamification techniques were implemented to encourage users to complete task. </p>
              </div>
            </div>
            <div className="todo-goal-image">
                <img src={header3} alt="Todo Goal" />
            </div>

{/* DETAIL */}
            <div className="todo-goal">
              <div className="todo-goal-text">
                <h3>Design Process</h3>
                <p>First, the research focused on the core functionality of a task management application to gain a thorough understanding of the project. Second, my colleagues and I worked together to build and organize a user flow diagram. Finally, I began with a low fidelity wireframe and continued to the next phase of the design.</p>
              </div>
            </div>

{/* MOBILE SREEN */}
            <div className="todo-moile-screen">
              <img src={header4} alt="TodoMobileScreen" />
            </div>

            {/* DETAIL */}
            <div className="todo-goal">
              <div className="todo-goal-text">
                <h3>Development Process</h3>
                <p>The backend logic was created with Python and Django. First, I constructed the user and task models. In addition, I linked the models to views, and the views to URLs. Finally, I moved to the next phase of development.</p>
              </div>
            </div>

            <div className="todo-moile-screen">
              <img src={header2} alt="Todo Mobile Screen" />
            </div>

{/* VIDEO */}
              <div className="tree-detail-image">
                <video src={todoVideo} controls></video>
            </div>

{/* VIDEO */}
              <div className="tree-detail-image">
                <video src={tododjangoVideo} controls></video>
            </div>

{/* ANIMATION */}

            <h2 className='todo-h2'><span>Thanks for scrolling</span></h2>

            <p className='todo-p'>Schedule a <a href="https://calendly.com/tunde_dev" target="_blank"  rel="noopener noreferrer">demo call</a> to learn more about this project.</p>
            </div>

{/* End work Detail */}
                    <div onClick={() => navigate('/Portfolio')} className="go_to1">
                                <p>Go back to Portfolio</p> 
                                <div className="icon">
                                    <i class="fas fa-angle-right"></i>
                                    <i class="fas fa-angle-right"></i>
                                </div>
                    </div>
            </div>
          </div>       
        </section>
      </div>
  )
}

export default Todo